export type LoyaltyEstimateItemType =
    | 'service'
    | 'membership'
    | 'add_on'
    | 'product'
    | 'custom_item';

export type LoyaltyEstimateSource = 'online_booking';

export interface LoyaltyEstimateItem {
    type: LoyaltyEstimateItemType;
    amount: number;
}

export interface LoyaltyEstimate {
    enabled: boolean;
    pointsToEarn: number;
    estimatedWalletValue: number;
}

export const emptyLoyaltyEstimate: LoyaltyEstimate = {
    enabled: false,
    pointsToEarn: 0,
    estimatedWalletValue: 0
};
